import type { NDateLocale } from './enUS'
import { enUS } from 'date-fns/locale'

const dateSwKE: NDateLocale = {
  name: 'sw-KE',
  locale: enUS
}

export default dateSwKE
